import { useCallback, useState } from 'react';

import { timeoutFetchSentryGuard } from 'Fetch';
import { getOfferBids } from 'PrivateAPI';

export type EnquiryOfferResponse = {
  enquiryId: number;
  vehicleDetails: {
    vrm: string;
  };
  vehicle: {
    make: {
      name: string;
    };
    model: string;
  };
  closingBid: {
    id: number;
    value: number;
    dealerContract: any; // we don't care right now.
  } | null;
  endOfSalePeriod: string;
  offerExpiry: string;
  bids: {
    value: number;
    createdAt: string;
  }[];
}

const useGetEnquiryOffers = () => {
  const [data, setData] = useState<EnquiryOfferResponse | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetched, setIsFetched] = useState<boolean>(false);

  const getEnquiryOffers = useCallback(async (dpEnquiryId: number) => {
    setIsLoading(true);
    try {
      const response = await getOfferBids(dpEnquiryId);
      setData(response?.closingBid ? response : null);
    } catch (err: any) {
      setData(undefined);
      timeoutFetchSentryGuard(err, () => {
        window.Sentry?.captureException?.(new Error(err), {
          extra: {
            dpEnquiryId,
          },
          tags: {
            fetch: 'Get an enquiry\'s offer',
          },
        });
      });
    }
    setIsLoading(false);
    setIsFetched(true);
  }, []);

  return {
    data,
    getEnquiryOffers,
    isFetched,
    isLoading,
    isSuccess: !!(data || data === null),
  };
};

export default useGetEnquiryOffers;
